module.exports = __webpack_public_path__ + "img/symbol_5.96a3b238.png";